import { createGlobalStyle } from 'styled-components';

export const RedesignVariables = createGlobalStyle`
  :root {
    /* Backgrounds */
    --rds-bg: #062f22;
    --rds-bg-deep: #042017;
    --rds-bg-card: #0e3528;

    /* Brand */
    --rds-plum: #4d2a3d;
    --rds-plum-dark: #3a1f2f;

    /* Text */
    --rds-cream: #f3ead8;
    --rds-cream-dim: #cfc6b3;
    --rds-text-on-gold: #1a1a1a;

    /* Accent */
    --rds-gold: #e9b949;
    --rds-gold-bright: #f3c34a;
    --rds-gold-first: #ffc02a;

    /* Input */
    --rds-input-bg: #0a1f1a;
    --rds-input-border: #1e4a3d;
    --rds-input-placeholder: #7a8a83;

    /* Borders / dividers */
    --rds-border: rgba(255, 255, 255, 0.07);
    --rds-border-subtle: rgba(255, 255, 255, 0.10);
    --rds-divider: rgba(255, 255, 255, 0.15);

    /* Typography */
    --rds-serif: 'Playfair Display', Georgia, serif;
  }
`;
